import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { branchIdForPartRun } from "../../rail/PartRunPhase/phase";
import { isPartLocationRun } from "./anchor";
import { matchingRailRun, type LocationRun } from "./runs";

/** Rail branch id shared by a scene site and its part boxes. */
export function locationBranchKey(
  run: LocationRun,
  layout: BookTimelineLayout,
): string {
  let keys = keysByLayout.get(layout);
  if (keys === undefined) {
    keys = new Map();
    keysByLayout.set(layout, keys);
  }
  let key = keys.get(run);
  if (key === undefined) {
    key = computeBranchKey(run, layout);
    keys.set(run, key);
  }
  return key;
}

const keysByLayout = new WeakMap<BookTimelineLayout, Map<LocationRun, string>>();

function computeBranchKey(
  run: LocationRun,
  layout: BookTimelineLayout,
): string {
  const partBranch = branchIdForPartRun(run);
  if (partBranch !== null) {
    return partBranch;
  }
  if (layout.rail.branches.some((branch) => branch.id === run.runId)) {
    return run.runId;
  }
  return matchingRailRun(run, layout.rail.branches, layout.beats).runId;
}

export function locationRunRole(run: LocationRun): "primary" | "secondary" {
  return isPartLocationRun(run) ? "secondary" : "primary";
}
